import { logDebugInfo } from '../ui_utils/Utils.ts';
export class ClientSocketMessageLoadTest {
    static processSocketData(data) {
        if (typeof data == 'number') {
            this.expectedSocketAmount = Number(data);
            this.receivedSocketAmount = 0;
            this.startingTime = Date.now();
            logDebugInfo('processSocketData', [
                '-------------------------------------'
            ]);
            logDebugInfo('processSocketData', [
                `Expecting ${this.expectedSocketAmount}`
            ]);
        }
        if (typeof data == 'string' && data == 'test') this.receivedSocketAmount += 1;
        if (typeof data == 'string' && data == 'done') {
            logDebugInfo('processSocketData', [
                `Expected ${this.expectedSocketAmount}`
            ]);
            logDebugInfo('processSocketData', [
                `Received ${this.receivedSocketAmount}`
            ]);
            logDebugInfo('processSocketData', [
                `Took ${Date.now() - this.startingTime}ms`
            ]);
            this.expectedSocketAmount = 0;
            this.receivedSocketAmount = 0;
            this.startingTime = 0;
        }
    }
}
ClientSocketMessageLoadTest.expectedSocketAmount = 0;
ClientSocketMessageLoadTest.receivedSocketAmount = 0;
ClientSocketMessageLoadTest.startingTime = 0;
